/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.29",
    versionName: "0.2.0-nightly.2025.12.29",
    versionChannel: "nightly",
    buildDate: "2025-12-29T00:09:42.298Z",
    commitHash: "36e9502f5a0ef2a9fcf9843f875bc1a39b8514a8",
};
